import type { AssetInfoFilesProps } from "./asset-info-files.type";

import { DownloadOutlined } from "@ant-design/icons";
import { Button, Table } from "antd";
import { useTranslation } from "react-i18next";

import { useAppNotification } from "@/modules/app-notification";
import { downloadFileWithNotify } from "@/modules/file-downloader";
import { FlexContainerJsx } from "@/modules/flex-container";
import { truncate } from "@/utilities/string";

export const AssetInfoFiles = ({ files }: AssetInfoFilesProps) => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();

  if (!files) return null;

  return (
    <FlexContainerJsx
      label={t("asset:form.assetFiles.label")}
      value={
        <Table
          showHeader={false}
          columns={[
            {
              dataIndex: "url",
              render: (url, { name }) => (
                <Button
                  type="link"
                  onClick={() => downloadFileWithNotify({ url, name, notify })}
                >
                  {truncate(name, 35)}
                </Button>
              ),
            },
            {
              dataIndex: "url",
              render: (url, { name }) => (
                <Button
                  type="text"
                  aria-label="download"
                  onClick={() => downloadFileWithNotify({ url, name, notify })}
                >
                  <DownloadOutlined />
                </Button>
              ),
            },
          ]}
          dataSource={files}
          rowKey="id"
          pagination={false}
        />
      }
      fullWidth
    />
  );
};
